import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import ExportDialog from "@/components/ExportDialog";

const TYPE_COLOR = {
  stock_in: "#10B981", consumption: "#0a8f8f", wastage: "#EF4444",
  stock_out: "#F59E0B", transfer: "#6366F1",
};

export default function Transactions() {
  const { data = [], isLoading } = useQuery({
    queryKey: ["transactions"],
    queryFn: () => api.get("/transactions").then((r) => r.data),
  });

  return (
    <div className="space-y-5" data-testid="transactions-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h2 className="font-serif text-3xl tracking-tight text-navy">Stock Transaction Ledger</h2>
          <p className="text-slate-500 text-sm mt-1">Full audit trail — every stock movement is attributable and timestamped (IST).</p>
        </div>
        <ExportDialog dataset="transactions" testid="transactions-export" />
      </div>

      <Card className="bg-white border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b border-slate-200 bg-slate-50">
                <th className="px-4 py-3 font-semibold">Date/Time (IST)</th>
                <th className="px-4 py-3 font-semibold">Type</th>
                <th className="px-4 py-3 font-semibold">Item</th>
                <th className="px-4 py-3 font-semibold text-right">Qty</th>
                <th className="px-4 py-3 font-semibold">Location</th>
                <th className="px-4 py-3 font-semibold">Reason</th>
                <th className="px-4 py-3 font-semibold">FEFO</th>
                <th className="px-4 py-3 font-semibold">Performed By</th>
              </tr>
            </thead>
            <tbody>
              {isLoading && <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-400">Loading…</td></tr>}
              {data.map((t, idx) => (
                <tr key={t._id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`txn-row-${idx}`}>
                  <td className="px-4 py-3 text-slate-600">{new Date(t.timestamp).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
                  <td className="px-4 py-3">
                    <span className="text-xs font-semibold px-2 py-0.5 rounded-full text-white capitalize" style={{ background: TYPE_COLOR[t.type] || "#64748B" }}>
                      {t.type.replace("_", " ")}
                    </span>
                  </td>
                  <td className="px-4 py-3 font-medium text-navy">{t.item_name}</td>
                  <td className="px-4 py-3 text-right">{t.qty}</td>
                  <td className="px-4 py-3 text-slate-600">{t.location_name}</td>
                  <td className="px-4 py-3 text-slate-600 capitalize">{t.reason_code}</td>
                  <td className="px-4 py-3">
                    {t.fefo_override ? <span className="text-xs font-semibold text-white px-2 py-0.5 rounded-full" style={{ background: "#F59E0B" }}>Override</span> : <span className="text-slate-300">—</span>}
                  </td>
                  <td className="px-4 py-3 text-slate-600">{t.performed_by_name}</td>
                </tr>
              ))}
              {!isLoading && data.length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-400">No transactions yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
